export default __webpack_public_path__ + "static/media/kitchen3-afterC-1440w.a1370fd0.avif";